
/**
 * 강의 난이도
 */
export type UpdateEnrollmentProgress200CourseLevel = typeof UpdateEnrollmentProgress200CourseLevel[keyof typeof UpdateEnrollmentProgress200CourseLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateEnrollmentProgress200CourseLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
